import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Click, ClickLink } from '../Common';
import newBrandDesignVars from './overwrite-vars.scss';

const NewClickLinkWrapper = styled.span`
  a:first-child {
    color: ${newBrandDesignVars.primary};
    text-decoration: underline;
  }
`;

const NewClickLink = (props: Click): ReactElement => {
  return (
    <NewClickLinkWrapper>
      <ClickLink {...props} />
    </NewClickLinkWrapper>
  );
};

export default NewClickLink;
